import React, {useCallback, useContext, useEffect, useState} from 'react';
import {FiChevronRight} from 'react-icons/fi';
import {Link, useLocation} from "react-router-dom";
import {ProjectContext} from "../../context/project-context";
import {menuResource} from "../../providers/menu";

const Menu = ({menusIsOpen}) => {
    const {user} = useContext(ProjectContext);
    const location = useLocation();
    const path = location.pathname;

    const [submenuOpen, setSubmenuOpen] = useState(null);
    const [userMenu, setUserMenu] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

    const handleMenu = useCallback(() => {
        const userPermissions = user?.permissions;

        if (!userPermissions) return;

        const newMenu = menuResource.map(m => {
            const hasMenuPermission = hasPermission(m.permissions, userPermissions);
            const filteredSubmenu = m.submenu.filter(sub => hasPermission(sub.permissions, userPermissions));

            if (hasMenuPermission || filteredSubmenu.length > 0) {
                return {
                    ...m,
                    submenu: filteredSubmenu
                };
            }

            return null;
        }).filter(menu => menu !== null);

        setUserMenu(newMenu)
    }, [user?.permissions])

    const hasPermission = (menuPermissions, userPermissions) => {
        return menuPermissions.some(permission => userPermissions.includes(permission));
    }

    useEffect(() => {
        handleMenu();
    }, [handleMenu]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 640);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const toggleSubmenu = (menu, suMenu) => {
        if (suMenu.length > 0) {
            setSubmenuOpen(submenuOpen === menu ? null : menu);
        }
    };

    return (
        <aside id="logo-sidebar"
               className={
                   `fixed top-0 left-0 z-40 w-full sm:w-64 h-screen pt-12 transition-transform bg-menu ` +
                   (isMobile ? (!menusIsOpen ? "-translate-x-full" : "") : (!menusIsOpen ? "sm:translate-x-0 -translate-x-full" : "hidden"))
               }>
            <div className="h-full pb-4 flex flex-col overflow-auto bg-menu">
                <div className="flex-grow">
                    {
                        userMenu.map((menu, index) => {
                            const {submenu, name, link, icon} = menu;
                            const pathToCompare = path.replace(/\/\d+$/, '');

                            const target = submenu
                                .filter(sub => pathToCompare === sub.link || pathToCompare === sub.link + '/form' || pathToCompare.startsWith(sub.link + '/'))
                                .sort((first, second) => second.link.length - first.link.length)[0];
                            const isActive = target !== undefined || (link && (pathToCompare === link || pathToCompare === link + '/form'));
                            const activeClass = `${isActive ? 'text-yellow-500' : ''}`;
                            return (
                                <div key={index}>
                                    <div
                                        className={`menu-item cursor-pointer flex justify-between items-center`}
                                        onClick={() => toggleSubmenu(name, submenu)}>
                                        {
                                            submenu.length === 0 &&
                                            <Link className={`flex items-center w-full p-3`} to={link}>
                                                <span className={`mr-3 ${activeClass}`}>{icon}</span>
                                                <span className={`menu-title ${activeClass}`}>{name}</span>
                                            </Link>
                                        }
                                        {
                                            submenu.length > 0 &&
                                            <div className={`flex items-center p-3`}>
                                                <span className={`mr-3 ${activeClass}`}>{icon}</span>
                                                <span className={`menu-title ${activeClass}`}>{name}</span>
                                            </div>
                                        }
                                        {
                                            submenu.length > 0 &&
                                            <span
                                                className={`ml-auto transform transition-transform ${(submenuOpen === name || target) ? 'rotate-90' : ''}`}>
                                                <FiChevronRight/>
                                            </span>
                                        }
                                    </div>
                                    {
                                        (submenuOpen === name || target) &&
                                        <div className="bg-subMenu pt-2 pb-2">
                                            {
                                                submenu.map((sub, subIndex) => (
                                                    <Link to={sub.link} key={subIndex}
                                                          className={"p-3 cursor-pointer sub-menu-item block " + (target?.link === sub.link ? "target" : "")}>
                                                        <div className="flex items-start">
                                                            <span className="mr-3 mt-0.5 shrink-0">{sub.icon}</span>
                                                            <span className={"menu-title"}>{sub.name}</span>
                                                        </div>
                                                    </Link>
                                                ))
                                            }
                                        </div>
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </aside>
    )
};

export default Menu;

